import * as React from "react";

function PrepareCompanyFile(props) {
  return (
    <svg
      viewBox="0 0 636.381 579.402"
      width={200}
      height={250}
      {...props}
    >
      <defs>
        <clipPath id="clip-path" transform="translate(708.71 96.2)">
          <rect className="cls-1" width={220} height={204} />
        </clipPath>
        <clipPath id="clip-path-2" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={0.29} y={-0.2} width={220} height={204} />
        </clipPath>
        <clipPath id="clip-path-3" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M219.45 110.94c0 60.54-48.89 109.62-109.2 109.62S1.06 171.48 1.06 110.94 50 1.32 110.25 1.32s109.2 49.08 109.2 109.62"
          />
        </clipPath>
        <clipPath id="clip-path-5" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={0.29}
            y={116.88}
            width={220}
            height={86.92}
          />
        </clipPath>
        <clipPath id="clip-path-6" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={-3.71}
            y={116.8}
            width={280}
            height={153}
          />
        </clipPath>
        <clipPath id="clip-path-7" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M72.66 116.88a76 76 0 000 152h203.63v-152z"
          />
        </clipPath>
        <clipPath id="clip-path-8" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={0.29} y={116.8} width={220} height={87} />
        </clipPath>
        <clipPath id="clip-path-9" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M117.15 193.79c0 3-17.07 5.49-38.12 5.49s-38.13-2.46-38.13-5.49S58 188.3 79 188.3s38.12 2.46 38.12 5.49"
          />
        </clipPath>
        <clipPath id="clip-path-11" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M193.38 141.17c0 1.66-13.51 3-30.19 3s-30.19-1.35-30.19-3 13.52-3 30.19-3 30.19 1.35 30.19 3"
          />
        </clipPath>
        <clipPath id="clip-path-13" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M110.54 41.76a2.31 2.31 0 002.31-2.32v-4.65a6.95 6.95 0 1113.89 0A1.16 1.16 0 00127.9 36h5.79a4.64 4.64 0 014.63 4.65 1.16 1.16 0 001.16 1.16h14.89a3.49 3.49 0 010 7h-43.83a3.49 3.49 0 010-7"
          />
        </clipPath>
        <clipPath id="clip-path-15" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M51 59.54a3.34 3.34 0 003.33-3.35V49.5a10 10 0 1120 0A1.67 1.67 0 0076 51.17h8.33a6.69 6.69 0 016.67 6.7 1.67 1.67 0 001.67 1.67h21.45a5 5 0 010 10H51a5 5 0 010-10"
          />
        </clipPath>
        <clipPath id="clip-path-17" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M43 132.17v57.9a2.4 2.4 0 002.39 2.41h59.13a2.4 2.4 0 002.4-2.41V138.2a2.4 2.4 0 00-2.4-2.41H69.93a2.4 2.4 0 01-2.15-1.33l-1.66-3.36a2.41 2.41 0 00-2.12-1.34H45.41a2.4 2.4 0 00-2.41 2.41"
          />
        </clipPath>
        <clipPath id="clip-path-19" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M44.72 128.8a2.44 2.44 0 00-2.43 2.45v59.09a2.45 2.45 0 002.43 2.46h60.13a2.45 2.45 0 002.44-2.46v-52.93a2.45 2.45 0 00-2.44-2.46h-35.2a2.44 2.44 0 01-2.18-1.36l-1.69-3.43a2.44 2.44 0 00-2.19-1.36z"
          />
        </clipPath>
        <clipPath id="clip-path-21" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={-703.71}
            y={-91.2}
            width={1344}
            height={402}
          />
        </clipPath>
        <clipPath id="clip-path-22" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={42.29} y={128.8} width={65} height={64} />
        </clipPath>
        <clipPath id="clip-path-23" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M38.76 135.8a2.44 2.44 0 00-2.47 2.42v52.15a2.45 2.45 0 002.47 2.43h65.53a2.46 2.46 0 01-2.48-2.43v-46.1a2.42 2.42 0 00-2.44-2.41H63.89a2.48 2.48 0 01-2.22-1.35L60 137.15a2.48 2.48 0 00-2.22-1.35z"
          />
        </clipPath>
        <clipPath id="clip-path-25" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={32.29} y={131.8} width={75} height={64} />
        </clipPath>
        <clipPath id="clip-path-26" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={36.29} y={135.8} width={68} height={57} />
        </clipPath>
        <clipPath id="clip-path-27" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M69.84 175.88a9.5 9.5 0 119.47-9.49 9.49 9.49 0 01-9.47 9.49m0-18.37a8.88 8.88 0 108.85 8.88 8.87 8.87 0 00-8.85-8.88m-.53 13.24a.84.84 0 01-.55-.19l-3.49-2.8a.89.89 0 01-.33-.59.89.89 0 01.78-1 .83.83 0 01.64.19l2.72 2.18 4-6.44a.89.89 0 011.21-.29.9.9 0 01.29 1.22l-4.48 7.28a.89.89 0 01-.59.41h-.15m-3.5-3.95a.22.22 0 00-.17.09.25.25 0 00-.06.2.27.27 0 00.1.18l3.49 2.8a.3.3 0 00.21 0 .26.26 0 00.18-.12l4.39-7.2a.26.26 0 00-.08-.36.27.27 0 00-.37.08l-4.31 7-3.24-2.58a.27.27 0 00-.17-.06"
          />
        </clipPath>
        <clipPath id="clip-path-29" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M69.84 176.67a10.28 10.28 0 10-10.25-10.28 10.26 10.26 0 0010.25 10.28m0-19.47a9.19 9.19 0 11-9.16 9.19 9.17 9.17 0 019.16-9.19"
          />
        </clipPath>
        <clipPath id="clip-path-31" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M69.84 177a10.59 10.59 0 1110.55-10.59A10.58 10.58 0 0169.84 177m0-20.56a10 10 0 109.94 10 10 10 0 00-9.94-10m0 19.46a9.5 9.5 0 119.47-9.49 9.49 9.49 0 01-9.47 9.49m0-18.37a8.88 8.88 0 108.85 8.88 8.87 8.87 0 00-8.85-8.88"
          />
        </clipPath>
        <clipPath id="clip-path-33" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M69 170.32a.57.57 0 00.84-.15l4.48-7.28a.59.59 0 00-.19-.8.58.58 0 00-.79.19L69.16 169l-3-2.39a.56.56 0 00-.8.09.57.57 0 00.09.81z"
          />
        </clipPath>
        <clipPath id="clip-path-35" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M69.31 170.75a.84.84 0 01-.55-.19l-3.49-2.8a.89.89 0 01-.33-.59.89.89 0 01.78-1 .83.83 0 01.64.19l2.72 2.18 4-6.44a.89.89 0 011.21-.29.9.9 0 01.29 1.22l-4.48 7.28a.89.89 0 01-.59.41h-.15m-3.5-3.95a.22.22 0 00-.17.09.25.25 0 00-.06.2.27.27 0 00.1.18l3.49 2.8a.3.3 0 00.21 0 .26.26 0 00.18-.12l4.39-7.2a.26.26 0 00-.08-.36.27.27 0 00-.37.08l-4.31 7-3.24-2.58a.27.27 0 00-.17-.06"
          />
        </clipPath>
        <clipPath id="clip-path-37" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M141.65 64.2l-9.29 48.66a2 2 0 001.61 2.4l49.55 9.57a2 2 0 002.38-1.63l8.32-43.6a2 2 0 00-1.62-2.4l-29-5.6a2 2 0 01-1.6-1.46l-.84-3.14a2 2 0 00-1.58-1.46l-15.55-3a2 2 0 00-2.38 1.63"
          />
        </clipPath>
        <clipPath id="clip-path-39" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M140.74 64.23l-9.44 49.29a2.08 2.08 0 001.64 2.43l50.38 9.68a2.07 2.07 0 002.43-1.65l8.46-44.15a2.07 2.07 0 00-1.65-2.43l-29.49-5.67a2.1 2.1 0 01-1.61-1.48l-.87-3.15a2.07 2.07 0 00-1.6-1.48l-15.82-3a1.78 1.78 0 00-.39 0 2.07 2.07 0 00-2.04 1.61z"
          />
        </clipPath>
        <clipPath id="clip-path-41" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={-252.71}
            y={-48.2}
            width={1133}
            height={526}
          />
        </clipPath>
        <clipPath id="clip-path-42" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={151.26}
            y={-330.08}
            width={324.83}
            height={1090.45}
            transform="rotate(-79.12 313.66234235 215.1450453)"
          />
        </clipPath>
        <clipPath id="clip-path-43" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={130.29} y={61.8} width={65} height={65} />
        </clipPath>
        <clipPath id="clip-path-44" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M140.74 64.23l-9.44 49.29a2.08 2.08 0 001.64 2.43l50.38 9.68a2.07 2.07 0 002.43-1.65l8.46-44.15a2.07 2.07 0 00-1.65-2.43l-29.49-5.67a2.1 2.1 0 01-1.61-1.48l-.87-3.15a2.07 2.07 0 00-1.6-1.48l-15.82-3a2.72 2.72 0 00-.39 0 2.07 2.07 0 00-2.04 1.61z"
          />
        </clipPath>
        <clipPath id="clip-path-46" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={125.29} y={57.8} width={75} height={72} />
        </clipPath>
        <clipPath id="clip-path-47" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={132.8}
            y={62.45}
            width={60.31}
            height={63.2}
            transform="rotate(-79.12 162.94910134 94.05265294)"
          />
        </clipPath>
        <clipPath id="clip-path-51" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={130.29} y={61.8} width={66} height={65} />
        </clipPath>
        <clipPath id="clip-path-52" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={136.08}
            y={66.38}
            width={54.34}
            height={55.45}
            transform="rotate(-79.12 163.23883583 94.10870686)"
          />
        </clipPath>
        <clipPath id="clip-path-54" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M140.74 64.23l-5.22 27.26-4.23 22.09a2.07 2.07 0 001.62 2.36l50.41 9.69a2.06 2.06 0 002.42-1.62l8.48-44.24a2.07 2.07 0 00-1.66-2.37l-29.49-5.67a2.1 2.1 0 01-1.61-1.48l-.87-3.15a2.09 2.09 0 00-1.59-1.48l-8.13-1.56-7.71-1.48a2.72 2.72 0 00-.39 0 2.07 2.07 0 00-2.03 1.65z"
          />
        </clipPath>
        <clipPath id="clip-path-56" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={127.29} y={57.8} width={72} height={72} />
        </clipPath>
        <clipPath id="clip-path-57" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={133.09}
            y={63.4}
            width={60.31}
            height={61.41}
            transform="rotate(-79.12 163.23883583 94.10870686)"
          />
        </clipPath>
        <clipPath id="clip-path-61" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={123.29} y={57.8} width={76} height={72} />
        </clipPath>
        <clipPath id="clip-path-62" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={131.04}
            y={60.92}
            width={60.31}
            height={65.58}
            transform="rotate(-79.12 161.19358931 93.712382)"
          />
        </clipPath>
        <clipPath id="clip-path-64" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M135.42 70.65L127 113.17a2 2 0 001.69 2.36l54.92 10.17a2 2 0 01-1.68-2.36l7.48-37.58a2 2 0 00-1.65-2.35L158 77.9a2.07 2.07 0 01-1.64-1.44l-.88-3A2.09 2.09 0 00153.8 72l-15.92-2.94a1.81 1.81 0 00-.4 0 2.08 2.08 0 00-2.06 1.59z"
          />
        </clipPath>
        <clipPath id="clip-path-66" transform="translate(708.71 96.2)">
          <rect
            className="cls-1"
            x={-254.71}
            y={-42.2}
            width={1137}
            height={508}
          />
        </clipPath>
        <clipPath id="clip-path-67" transform="translate(708.71 96.2)">
          <polygon
            className="cls-2"
            points="-253.96 266.84 820.82 465.79 882.17 157.47 -192.6 -41.48 -253.96 266.84"
          />
        </clipPath>
        <clipPath id="clip-path-68" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={126.29} y={68.8} width={64} height={57} />
        </clipPath>
        <clipPath id="clip-path-71" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={122.29} y={58.8} width={76} height={71} />
        </clipPath>
        <clipPath id="clip-path-72" transform="translate(708.71 96.2)">
          <polygon
            className="cls-2"
            points="123.06 117.44 185.94 129.08 197.44 71.27 134.56 59.63 123.06 117.44"
          />
        </clipPath>
        <clipPath id="clip-path-76" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={126.29} y={67.8} width={67} height={58} />
        </clipPath>
        <clipPath id="clip-path-77" transform="translate(708.71 96.2)">
          <polygon
            className="cls-2"
            points="126.56 115.15 183.56 125.7 192.81 79.22 135.81 68.67 126.56 115.15"
          />
        </clipPath>
        <clipPath id="clip-path-79" transform="translate(708.71 96.2)">
          <path
            className="cls-2"
            d="M135.43 70.58L127 113.21a2 2 0 001.63 2.31l55 10.18a2 2 0 01-1.68-2.36l7.48-37.58a2 2 0 00-1.65-2.35L158 77.9a2.07 2.07 0 01-1.64-1.44l-.88-3A2.09 2.09 0 00153.8 72l-9.6-1.77-6.35-1.18a2.31 2.31 0 00-.37 0 2.09 2.09 0 00-2.05 1.53z"
          />
        </clipPath>
        <clipPath id="clip-path-81" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={122.29} y={64.8} width={75} height={65} />
        </clipPath>
        <clipPath id="clip-path-82" transform="translate(708.71 96.2)">
          <polygon
            className="cls-2"
            points="133.44 65.3 196.31 76.94 185.94 129.08 123.06 117.44 133.44 65.3"
          />
        </clipPath>
        <clipPath id="clip-path-86" transform="translate(708.71 96.2)">
          <rect className="cls-1" x={122.29} y={55.8} width={79} height={74} />
        </clipPath>
        <clipPath id="clip-path-87" transform="translate(708.71 96.2)">
          <polygon
            className="cls-2"
            points="135.13 56.8 200.35 68.87 188.29 129.51 123.06 117.44 135.13 56.8"
          />
        </clipPath>
        <style>
          {
                        "\n      .cls-1,.cls-2{fill:none}.cls-2{clip-rule:evenodd}.cls-4{clip-path:url(#clip-path)}.cls-5{clip-path:url(#clip-path-2)}.cls-6{fill:#f3f4f5}.cls-7{clip-path:url(#clip-path-3)}.cls-8{fill:#eaeced}.cls-9{clip-path:url(#clip-path-5)}.cls-10{isolation:isolate}.cls-11{clip-path:url(#clip-path-6)}.cls-12{clip-path:url(#clip-path-7)}.cls-13{clip-path:url(#clip-path-8)}.cls-14{clip-path:url(#clip-path-9)}.cls-15{fill:#f0f1f3}.cls-16{clip-path:url(#clip-path-11)}.cls-17{clip-path:url(#clip-path-13)}.cls-18{fill:#f5f5f6}.cls-19{clip-path:url(#clip-path-15)}.cls-20{clip-path:url(#clip-path-17)}.cls-21{fill:#c0c5ca}.cls-22{clip-path:url(#clip-path-19)}.cls-23{clip-path:url(#clip-path-21)}.cls-24{clip-path:url(#clip-path-22)}.cls-25{clip-path:url(#clip-path-23)}.cls-26{clip-path:url(#clip-path-25)}.cls-27{clip-path:url(#clip-path-26)}.cls-28{fill:#ec0677}.cls-29{clip-path:url(#clip-path-27)}.cls-30{clip-path:url(#clip-path-29)}.cls-31{clip-path:url(#clip-path-31)}.cls-32{clip-path:url(#clip-path-33)}.cls-33{clip-path:url(#clip-path-35)}.cls-34{clip-path:url(#clip-path-37)}.cls-35{clip-path:url(#clip-path-39)}.cls-36{clip-path:url(#clip-path-41)}.cls-37{clip-path:url(#clip-path-42)}.cls-38{clip-path:url(#clip-path-43)}.cls-39{clip-path:url(#clip-path-44)}.cls-40{clip-path:url(#clip-path-46)}.cls-41{clip-path:url(#clip-path-47)}.cls-42{clip-path:url(#clip-path-51)}.cls-43{clip-path:url(#clip-path-52)}.cls-44{clip-path:url(#clip-path-54)}.cls-45{clip-path:url(#clip-path-56)}.cls-46{clip-path:url(#clip-path-57)}.cls-47{clip-path:url(#clip-path-61)}.cls-48{clip-path:url(#clip-path-62)}.cls-49{clip-path:url(#clip-path-64)}.cls-50{clip-path:url(#clip-path-66)}.cls-51{clip-path:url(#clip-path-67)}.cls-52{clip-path:url(#clip-path-68)}.cls-53{fill:#d5d8dc}.cls-54{clip-path:url(#clip-path-71)}.cls-55{clip-path:url(#clip-path-72)}.cls-56{clip-path:url(#clip-path-76)}.cls-57{clip-path:url(#clip-path-77)}.cls-58{clip-path:url(#clip-path-79)}.cls-59{clip-path:url(#clip-path-81)}.cls-60{clip-path:url(#clip-path-82)}.cls-61{clip-path:url(#clip-path-86)}.cls-62{clip-path:url(#clip-path-87)}\n    "
                    }
        </style>
      </defs>
      <g
        className="cls-4"
        style={{}}
        transform="matrix(2.512443, 0, 0, 2.512443, -1728.775757, -212.535477)"
      >
        <g className="cls-5">
          <rect className="cls-6" x={690} y={88} width={257} height={257} />
        </g>
        <g className="cls-7">
          <g className="cls-5">
            <rect
              className="cls-8"
              x={704.77}
              y={92.52}
              width={228.39}
              height={229.25}
            />
          </g>
        </g>
        <g className="cls-9">
          <g className="cls-10">
            <g className="cls-11">
              <g className="cls-12">
                <g className="cls-13">
                  <rect
                    className="cls-6"
                    x={700.69}
                    y={208.08}
                    width={289.3}
                    height={161.95}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-14">
          <g className="cls-5">
            <rect
              className="cls-15"
              x={744.61}
              y={279.5}
              width={86.25}
              height={20.99}
            />
          </g>
        </g>
        <g className="cls-16">
          <g className="cls-5">
            <rect
              className="cls-15"
              x={836.71}
              y={229.36}
              width={70.38}
              height={16.02}
            />
          </g>
        </g>
        <g className="cls-17">
          <g className="cls-5">
            <rect
              className="cls-18"
              x={810.78}
              y={119.02}
              width={60.78}
              height={30.92}
            />
          </g>
        </g>
        <g className="cls-19">
          <g className="cls-5">
            <rect
              className="cls-6"
              x={749.7}
              y={130.66}
              width={83.13}
              height={40.12}
            />
          </g>
        </g>
        <g className="cls-20">
          <g className="cls-5">
            <rect
              className="cls-21"
              x={746.73}
              y={220.96}
              width={73.92}
              height={72.72}
            />
          </g>
        </g>
        <g className="cls-22">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-23">
                <g className="cls-24">
                  <rect className="cls-21" width={1354} height={412} />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-25">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-26">
                <g className="cls-27">
                  <rect
                    className="cls-28"
                    x={736}
                    y={223}
                    width={85}
                    height={74}
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-29">
          <g className="cls-5">
            <rect
              className="cls-6"
              x={764.09}
              y={248.09}
              width={28.93}
              height={28.99}
            />
          </g>
        </g>
        <g className="cls-30">
          <g className="cls-5">
            <rect
              className="cls-6"
              x={763.31}
              y={247.31}
              width={30.49}
              height={30.56}
            />
          </g>
        </g>
        <g className="cls-31">
          <g className="cls-5">
            <rect
              className="cls-6"
              x={763}
              y={247}
              width={31.11}
              height={31.18}
            />
          </g>
        </g>
        <g className="cls-32">
          <g className="cls-5">
            <rect
              className="cls-6"
              x={768.95}
              y={253.21}
              width={19.11}
              height={18.43}
            />
          </g>
        </g>
        <g className="cls-33">
          <g className="cls-5">
            <rect
              className="cls-6"
              x={768.65}
              y={252.9}
              width={19.72}
              height={19.05}
            />
          </g>
        </g>
        <g className="cls-34">
          <g className="cls-5">
            <rect
              className="cls-21"
              x={836.03}
              y={153.74}
              width={71.93}
              height={72.33}
            />
          </g>
        </g>
        <g className="cls-35">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-36">
                <g className="cls-37">
                  <g className="cls-38">
                    <rect
                        className="cls-21"
                        x={451.4}
                        y={43.9}
                        width={1141.97}
                        height={534.88}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-39">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-40">
                <g className="cls-41">
                  <g className="cls-38">
                    <rect
                        className="cls-21"
                        x={829.96}
                        y={149.67}
                        width={83.41}
                        height={81.16}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-39">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-42">
                <g className="cls-43">
                  <g className="cls-38">
                    <rect
                        className="cls-21"
                        x={834.62}
                        y={153.39}
                        width={74.67}
                        height={73.83}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-44">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-45">
                <g className="cls-46">
                  <g className="cls-38">
                    <rect
                        className="cls-21"
                        x={831.13}
                        y={149.9}
                        width={81.65}
                        height={80.82}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-44">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-47">
                <g className="cls-48">
                  <g className="cls-38">
                    <rect
                        className="cls-21"
                        x={827.03}
                        y={149.11}
                        width={85.75}
                        height={81.61}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-49">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-50">
                <g className="cls-51">
                  <g className="cls-52">
                    <rect
                        className="cls-53"
                        x={449.76}
                        y={49.72}
                        width={1146.13}
                        height={517.27}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-49">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-54">
                <g className="cls-55">
                  <g className="cls-52">
                    <rect
                        className="cls-53"
                        x={826.77}
                        y={150.83}
                        width={84.38}
                        height={79.45}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-49">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-56">
                <g className="cls-57">
                  <g className="cls-52">
                    <rect
                        className="cls-53"
                        x={830.27}
                        y={159.88}
                        width={76.25}
                        height={67.03}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-58">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-59">
                <g className="cls-60">
                  <g className="cls-52">
                    <rect
                        className="cls-53"
                        x={826.77}
                        y={156.5}
                        width={83.25}
                        height={73.78}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g className="cls-58">
          <g className="cls-5">
            <g className="cls-10">
              <g className="cls-61">
                <g className="cls-62">
                  <g className="cls-52">
                    <rect
                        className="cls-53"
                        x={826.77}
                        y={148}
                        width={87.29}
                        height={82.72}
                      />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default PrepareCompanyFile;
